<template>
    <div :class="{
        'info': true,
        'info--full': hasLeader && full,
        'info--center': center,
    }">
        <yxt-tooltip 
            class="item"
            effect="dark"
            :disabled="!full"
            :enterable="false" 
            :content="content"
            :open-delay="0"
            :hide-delay="0"
            :placement="placement"
        >
            <div ref="content" class="info__content">
              <slot></slot>
            </div>
        </yxt-tooltip>
        <yxt-tag v-if="leader" size="medium">{{$t('pc_biz_group_leader' /* 组长 */)}}</yxt-tag>
    </div>
</template>
<script>
export default {
  props: {
    placement: {
      type: String,
      default: 'top'
    },
    content: {
      type: String,
      require: true
    },
    leader: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      full: false,
      hasLeader: false,
      restart: 0
    };
  },
  watch: {
    content() {
      this.$nextTick(()=>{
        this.isFullContent();
      });
    }
  },
  mounted() {
    // 第一次渲染  宽度是 0
    setTimeout(() => {
      this.isFullContent();
    }, 100);
  },
  methods: {
    isFullContent() {
      if (this.$refs.content.clientWidth - this.$el.clientWidth >= 0) {
        this.full = true;
      } else {
        this.full = false;
      }
      if (this.$refs.content.clientWidth - this.$el.clientWidth < 46 && this.leader) {
        this.hasLeader = true;
      } else {
        this.hasLeader = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.info{
    width: 100%;
    display: flex;
    align-items: center;

    &__content{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
    }
    /deep/ .yxt-tag{
        margin-left: 8px
    }
}
.info--center{
  justify-content: center;
}
.info--full{
    .info__content{
        width: calc(100% - 38px);
    }
}
</style>
